module.exports = __webpack_public_path__ + "media/pro/pay_with_paypal@2x-ac5d6fd9.png";